export { default } from './BeverageProductATF'
